import { Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';

import { IconDirective } from '@coreui/icons-angular';
import {
  ButtonCloseDirective,
  ContainerComponent,
  ShadowOnScrollDirective,
  SidebarBrandComponent,
  SidebarComponent,
  SidebarFooterComponent,
  SidebarHeaderComponent,
  SidebarNavComponent,
  SidebarToggleDirective,
  SidebarTogglerDirective,
  ToastBodyComponent,
  ToastComponent,
  ToasterComponent,
} from '@coreui/angular';

import { AdminFooterComponent }      from './admin-footer/admin-footer.component';
import { AdminHeaderComponent }      from './admin-header/default-header.component';
import { PlanExpiryBannerComponent } from '../../components/plan-expiry-banner/plan-expiry-banner.component';
import { PlanLimitAlertComponent }   from '../../components/plan-limit-alert/plan-limit-alert.component';
import { PlanExpiredModalComponent } from '../../components/plan-expired-modal/plan-expired-modal.component';
import { AlertsPanelService }        from '../../services/alerts-panel.service';
import { VersionService }            from '../../services/version.service';

import { allNavItems, NavItemWithPermission } from './_nav';
import { ErrorAdvicerService }  from '../../services/errorAdvicer.service';
import { AuthService }          from '../../services/auth';
import { ClientService }        from '../../services/api/client.service';
import { ClientStoreService }   from '../../services/store/client-store.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
  standalone: true,
  imports: [
    SidebarComponent,
    SidebarHeaderComponent,
    SidebarBrandComponent,
    RouterLink,
    IconDirective,
    NgScrollbar,
    SidebarNavComponent,
    SidebarFooterComponent,
    SidebarToggleDirective,
    SidebarTogglerDirective,
    AdminHeaderComponent,
    ShadowOnScrollDirective,
    ContainerComponent,
    RouterOutlet,
    AdminFooterComponent,
    PlanExpiryBannerComponent,
    PlanLimitAlertComponent,
    PlanExpiredModalComponent,
    ToasterComponent,
    ToastComponent,
    ToastBodyComponent,
    ButtonCloseDirective,
  ],
})
export class AdminLayoutComponent implements OnInit {
  public navItems: NavItemWithPermission[] = [];

  private authServ        = inject(AuthService);
  private errorAdvicerServ = inject(ErrorAdvicerService);
  private versionService   = inject(VersionService);
  public  errorMessage: string | null = null;
  public  version: string = '';
  readonly alertsPanel    = inject(AlertsPanelService);

  private _clientService = inject(ClientService);
  private _clientStore   = inject(ClientStoreService);

  ngOnInit(): void {
    this.version = this.versionService.version;

    this.authServ.userData$.subscribe(() => {
      this.navItems = this.allowedItems(allNavItems);
    });

    this.errorAdvicerServ.errorMessage$.subscribe({
      next: (e: string | null) => { this.errorMessage = e; },
    });

    this.getData();
  }

  /**
   * Deja en el menu solo lo que el usuario tiene permitido.
   *
   * Recorre tambien los hijos, y descarta un grupo cuando se queda sin hijos
   * visibles: un grupo que no lleva a ninguna parte solo estorba.
   */
  private allowedItems(items: NavItemWithPermission[]): NavItemWithPermission[] {
    return items.reduce<NavItemWithPermission[]>((visibles, item) => {
      if (item.permission && !this.authServ.isPermit(item.permission)) return visibles;

      if (!item.children) {
        visibles.push(item);
        return visibles;
      }

      const children = this.allowedItems(item.children);
      if (children.length) visibles.push({ ...item, children });

      return visibles;
    }, []);
  }

  getData(): void {
    this._clientService.getAll().subscribe({
      next: (res) => { this._clientStore.setClients(res.data); },
    });
  }
}
